<template>
  <div
    class="v-input-tag"

    @click="onclick">
    <div
      v-for="(item,index) in tagsArr"
      :key='index'
      @dragenter="dragenter($event, index)"
      @dragover="dragover($event, index)"
      @dragstart="dragstart(index)">
      <el-tag
        type="info"
        closable
        draggable="true"
        :disable-transitions="false"
        size="small"
        @click="onclick"
        @close="removeTag(index,item)">{{item}}
      </el-tag>
    </div>

    <el-input
      ref="inputTag"
      v-model="inputValue"
      :placeholder="placeholder"
      :style="inputStyle"
      class="inputTag"
      type="text"
      @keyup.enter.native="handleEnter"
    />
  </div>
</template>

<script>
export default {
  name: 'inputTags',
  props: {
    value: {
      type: [String, Number,Array],
      default: ''
    },
    parentArr: {
      type: Array,
      default () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: 'press enter to add tag'
    }
  },
  data () {
    return {
      inputValue: '',
      tagsArr:[],
      dragIndex:0
    }
  },
  computed: {
    inputStyle () {
      let style = {}
      style.width = `${this.inputLength}px`
      return style
    },
  },
  watch: {
    tagsArr () {
      this.$emit('on-change', this.tagsArr)
    },
    value: {
      immediate: true,
      handler(val) {
        this.tagsArr = val
      }
    }
  },
  methods: {
    dragstart(index) {
      this.dragIndex = index
    },
    dragenter(e, index) {
      e.preventDefault()
      // 避免源对象触发自身的dragenter事件
      if (this.dragIndex !== index) {
        const source = this.value[this.dragIndex]

        this.value.splice(this.dragIndex, 1)
        this.value.splice(index, 0, source)
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index
      }
    },
    dragover(e, index) {
      e.preventDefault()
    },
    checkValue(value) {
      if(value === '' || value === null) {
        return false
      }
      return true
    },
    removeTag (index, item) {
      this.value.splice(index, 1)
    },
    handleEnter () {
      if (this.tagsArr.indexOf(this.inputValue) > -1) {
        this.$emit('on-repeat', true)
        this.inputValue = ''
        return
      }
      this.tagsArr.push(this.inputValue)
      this.inputValue = ''
      this.$emit('input', this.tagsArr)
    },
    onclick() {
      this.$nextTick(()=>{
        this.$refs.inputTag.focus()
      })
    }
  }
}
</script>

<style lang="scss">
.v-input-tag {
  box-sizing:border-box;
  background-color: white;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  font-size: 12px;
  text-align: left;
  padding-left: 5px;
  word-wrap: break-word;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .el-tag{
    margin: 2px 0 2px 6px;
  }
  /* input */
  .inputTag{
    min-width: 150px;
    width: auto;
    border: 0!important;
    .el-input__inner {
      font-size: 12px;
      border: 0!important;
      border: none;
      box-shadow: none;
      outline: none;
      background-color: transparent;
      padding: 0;
      width: auto;
      min-width: 150px;
      height: 32px;
      line-height: 32px;
      margin-left: 5px
    }
  }
  /deep/.el-input__inner {
    font-size: 12px;
    border: 0!important;
    //border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    padding: 0;
    width: auto;
    min-width: 150px;
    vertical-align: top;
    height: 32px;
    color: #495060;
    line-height: 32px;
  }
}

</style>

